import React from "react";
import Images from "../data/Images";
import Slider from "./Slider";
import {
  ShieldCheck,
  ClipboardList,
  Cpu,
  BadgeCheck,
  AlertTriangle,
} from "lucide-react";
import HeroSlider from "../components/HeroSlider";

const Home = () => {
  const features = [
    {
      title: "Security Audits",
      desc: "Thorough evaluations to identify risks and improve systems.",
      icon: ShieldCheck,
    },
    {
      title: "Security Planning",
      desc: "Custom security plans for full organizational protection.",
      icon: ClipboardList,
    },
    {
      title: "Technology Integration",
      desc: "Implement latest tools like surveillance and access control.",
      icon: Cpu,
    },
    {
      title: "Compliance Guidance",
      desc: "Ensure you meet all legal security obligations.",
      icon: BadgeCheck,
    },
    {
      title: "Risk Assessment",
      desc: "Evaluate and reduce vulnerabilities across your assets.",
      icon: AlertTriangle,
    },
  ];

  return (
    <div className="space-y-24">
      <section
        className="h-auto bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/image.jpg')" }}
      >
        <HeroSlider />
      </section>

      <section className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 items-center gap-12">
        <div>
          <h1 className="text-4xl font-bold mb-4 text-red-800 leading-tight">
            Facing the Future <br /> Together
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            At New Way Security, we are your trusted partner in safeguarding
            what matters most – your business, your assets, and your peace of
            mind. As the premier security consultancy company in Canada, we
            deliver tailored security solutions as unique as your needs.
          </p>
          <a
            href="#service"
            className="inline-block bg-red-800 text-white px-6 py-3 rounded-lg font-medium hover:bg-red-700 transition"
          >
            Our Services
          </a>
        </div>
        <div>
          <img
            src={Images.security}
            alt="Security"
            className="rounded-xl shadow-lg w-full"
          />
        </div>
      </section>

      <section className="border border-red-800 bg-red-800 py-12">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={Images.expert}
              alt="Team of Experts"
              className="rounded-xl shadow-md"
            />
          </div>
          <div>
            <h2 className="text-2xl text-white font-semibold mb-4">
              Our Team of Experts
            </h2>
            <p className="text-white-700 mb-6">
              Our seasoned professionals bring extensive experience and a deep
              understanding of the Canadian security landscape. We provide
              informed insights and effective solutions tailored to your unique
              security challenges.
            </p>
            <div className="flex gap-4 flex-wrap">
              <a
                href="/career"
                className="bg-white text-red-800 px-5 py-2 rounded-lg border border-white hover:bg-transparent hover:text-white"
              >
                Apply for Job
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="service" className="max-w-7xl mx-auto space-y-12">
        <div className="text-center">
          <h2 className="text-3xl text-red-800 font-bold">Our Services</h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            We offer a comprehensive range of security services to address
            various concerns, including:
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Condominium Services",
              desc: "Friendly and professional front-desk staff providing building access control and visitor assistance...",
              img: Images.service1,
              link: "/services/condominium-services",
            },
            {
              title: "Mobile Patrol Units",
              desc: "Businesses and property owners face evolving security challenges...",
              img: Images.service2,
              link: "/services/mobile-patrol",
            },
            {
              title: "Event Security Solutions",
              desc: "Organizing successful events requires meticulous planning and strong security...",
              img: Images.service3,
              link: "/services/event-security",
            },
            {
              title: "Residential Security Solutions",
              desc: "Safeguarding one’s residence is critical in today’s environment...",
              img: Images.service5,
              link: "/services/residential-security",
            },
          ].map((service, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-xl overflow-hidden flex flex-col"
            >
              <img
                src={service.img}
                alt={service.title}
                className="h-48 w-full object-cover"
              />
              <div className="p-5 flex flex-col justify-between grow">
                <h3 className="font-semibold text-red-800 text-lg mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 flex-grow">
                  {service.desc}
                </p>
                <a
                  href={service.link}
                  className="mt-4 text-red-800 font-medium hover:underline"
                >
                  Read more
                </a>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* <section className="border border-red-800 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-red-800 text-center mb-12">
            Security Technology Integration
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map(({ title, desc, icon: Icon }, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                <Icon className="h-8 w-8 text-red-800 mb-4" />
                <h3 className="text-xl text-red-800 font-semibold mb-2">
                  {title}
                </h3>
                <p className="text-gray-600 text-sm">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-2xl text-red-800 font-bold mb-4">
            A Little About Us
          </h2>
          <p className="text-gray-700 mb-6">
            New Way Security is a top-tier consultancy company based in Canada.
            Our mission is to protect what matters most through cutting-edge
            technology, seasoned expertise, and customer-focused services.
            Everyone deserves to feel secure—and we’re here to make that happen.
          </p>
          <a href="/About" className="text-red-800 hover:underline font-medium">
            More about us
          </a>
        </div>
        <div className="space-y-4">
          {[
            ["Commercial Security", "/services/commercial-security"],
            ["Event Security", "/services/event-security"],
            ["Residential Security", "/services/residental-security"],
            ["Vip Security", "/services/vip-security"],
            ["Condominium Security", "/services/condominium-security"],
            ["Tailored Services", "/services/tailored-services"],
          ].map(([label, link]) => (
            <a
              key={label}
              href={link}
              className="flex items-center gap-3 bg-gray-100 px-4 py-2 rounded-lg hover:bg-gray-200 transition"
            >
              <img src={Images.logo} alt="" className="w-6 h-6" />
              <span className="text-sm text-black font-medium">{label}</span>
            </a>
          ))}
          <div className="my-4">
            <a
              href="/services"
              className="text-red-800 hover:underline font-medium"
            >
              More Services
            </a>
          </div>
        </div>
      </section>

      <section className="bg-red-800 text-white py-16">
        <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 items-center gap-12">
          <img
            src={Images.homecontact}
            alt="Contact"
            className="rounded-lg shadow-md"
          />
          <div>
            <h2 className="text-3xl font-bold mb-4">
              Contact Us <span className="text-yellow-300">Today</span>
            </h2>
            <p className="mb-6">
              Ready to enhance your organization’s security? Reach out today for
              a free consultation. Let’s build a safer tomorrow—together.
            </p>
            <a
              href="/Contact"
              className="bg-white text-red-800 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition"
            >
              Obtain a Quote
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
